let openDropdownKey = null;
const listeners = new Set();

export const setOpenDropdown = key => {
    openDropdownKey = key;
    listeners.forEach(listener => {
        try {
            listener(openDropdownKey);
        } catch (error) {
            // Ignore listener failures so one broken dropdown does not block others.
        }
    });
};

export const getOpenDropdown = () => openDropdownKey;

export const addDropdownListener = listener => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};
